import React from 'react';
import moment from 'moment';
import { Button, Table, Tabs, Select, Checkbox, Spin } from 'antd';
import { mobileColumns, generateNameFilterColumns } from '../table/columns';
import '../App.css';
import BaseOptimizer from './BaseOptimizer';
import LineupFeedback from '../lineupMetadata/LineupFeedback';

import 'antd/dist/antd.css';

const TabPane = Tabs.TabPane;
const Option = Select.Option;

class Optimizer extends BaseOptimizer {
  render() {
    const { error, lastUpdated } = this.state;

    if (error) {
      throw new Error(this.state.error);
    }

    return (
      <div className="App">
        <h3>DraftFast ({this.props.version})</h3>

        <div className="Mobile-picker">
          <div className="League-mobile">
            <Select
              defaultValue="NFL"
              style={{ width: 120 }}
              onChange={this.onLeagueChange}
            >
              <Option value="NFL">NFL 11/24 Main</Option>
            </Select>
          </div>
          <div className="Game-mobile">
            <Select
              defaultValue="FanDuel"
              style={{ width: 120 }}
              onChange={this.onGameChange}
            >
              <Option value="draftkings">DraftKings</Option>
              <Option value="fanduel">FanDuel</Option>
            </Select>
          </div>
        </div>

        {lastUpdated && (
          <h4 className={'LastUpdated'}>Demo of DraftFast functionality</h4>
        )}
        <h4>DFS lineups in the click of a button.</h4>
        <Tabs defaultActiveKey="1">
          <TabPane tab="Optimizer" key="1">
            <Button
              onClick={() => this.generate()}
              type="primary"
              icon="plus"
              loading={!this.state.loaded}
            >
              Generate
            </Button>
            {!this.state.loaded && (
              <div className="Table-results">
                <Spin size="large" />
              </div>
            )}
            {this.state.loaded &&
              this.state.rosters &&
              this.state.rosters.map((r, i) => (
                <div key={r.proj} className="Table-results">
                  <LineupFeedback
                    name={`Lineup ${i + 1}`}
                    projected={r.proj}
                    optimism={r.optimism}
                    spent={r.salary}
                    selectedOver={this.state.selectedOver}
                  />
                  <Table
                    size="middle"
                    dataSource={r.lineup || []}
                    columns={mobileColumns({})}
                    pagination={false}
                  />
                </div>
              ))}
          </TabPane>
          <TabPane tab="Players" key="2">
            <Table
              size="medium"
              dataSource={this.state.players || []}
              columns={generateNameFilterColumns(mobileColumns, {
                ctx: this,
              }).concat([
                {
                  title: 'Locked?',
                  dataIndex: 'locked',
                  key: 'locked',
                  render: (a, player) => {
                    return (
                      <Checkbox
                        onChange={e => {
                          if (e.target.checked) {
                            this.addLocked(player.name);
                          } else {
                            this.removeLocked(player.name);
                          }
                        }}
                      />
                    );
                  },
                },
              ])}
              pagination={true}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default Optimizer;



// WEBPACK FOOTER //
// ./src/optimizer/MobileOptimizer.js